module.exports = __webpack_public_path__ + "static/media/video-7.4722152c.jpg";